import { initAmplitude } from '~/utils/amplitude/init'

export const setUserIdAmplitude = async user => {
  if (window.amplitude !== undefined) {
    if (user?.amplitudeUserId) {
      window.amplitude.setUserId(user?.amplitudeUserId)
    }
    return
  }
  await initAmplitude()
}

const mapAmplitudeProduct = (product, overrides = {}) => {
  const basePrice = product?.adobeRecord?.productDiscountPrice || product.productDiscountPrice
  const netPrice = basePrice * 1
  const productName = product?.adobeRecord?.productName || product.productName
  const productId = product.productPartNumber

  const breadCrumbsList = product?.itemCategoriesDTO?.breadCrumbsDTOList[0]?.breadCrumbsList || []
  const Dept = breadCrumbsList[0]?.name
  const Category = breadCrumbsList[1]?.name
  const SubCategory = breadCrumbsList[2]?.name

  return {
    ProductID: productId,
    ProductName: product?.adobeRecord?.productName || product.productName,
    BasePrice: basePrice,
    NetPrice: netPrice,
    Units: 1,
    BOGO: product?.adobeRecord?.bogo || product.bogo,
    Dept,
    Category,
    SubCategory,
    IsSuggestion: false,
    ProductBrand: product?.adobeRecord?.productVendor || product.productVendor,
    ProductBrandGroup: (product?.adobeRecord?.swansonItem || product.swansonItem) ? "Swanson": "Partner Brand",
    InventoryStatus: product?.adobeRecord?.statusMessage || product.statusMessage,
    ...(productName && { ProductIDDesc: `${productId}-${productName}` }),
    ...overrides
  }
}

const mapAmplitudeCartProduct = (product, overrides = {}) => {
  return {
    PageName: new URL(window.location.href).pathname,
    ...mapAmplitudeProduct(product, overrides),
    ...overrides
  }
}

const mapAmplitudeUser = (userInfo, overrides = {}) => {
  return {
    RewardsMember: null,
    EasyRefillSubscriber: null,
    PaymentMethodSaved: null,
    PrimaryAddressSaved: null,
    TotalOrdersLTD: null,
    TotalSalesLTD: null,
    FirstOrderDate: null,
    LastOrderDate: null,
    AccountCreationDate: null,
    SourceCode: null,
    ...overrides
  }
}

const trackEvent = async (eventName, eventProperties) => {
  await initAmplitude();
  window.amplitude.track(eventName, eventProperties)
}

const extractPath = (link) => {
  try {
    const parsedUrl = new URL(link, window.location.origin);

    if (parsedUrl.origin === window.location.origin) {
      return parsedUrl.pathname + parsedUrl.hash;
    }

    return link;
  } catch {
    return '';
  }
};

const trackHeaderFooterClicked = (data = {}) => {
  const payload = {
    HeaderFooterType: '',
    HeaderFooterPagePath: window.location.pathname,
    L1: '',
    L2: '',
    L3: '',
    ...data,
    HeaderFooterLink: extractPath(data.HeaderFooterLink || ''),
  }

  const withoutEmptyProperties = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value)
  );

  trackEvent('header footer clicked', withoutEmptyProperties)
}

export default function useAmplitude() {
  return {
    mapAmplitudeProduct,
    mapAmplitudeUser,
    mapAmplitudeCartProduct,
    trackEvent,
    trackHeaderFooterClicked
  }
}
